import type { ICustomMenuActionProvider } from '@core/interfaces/ICustomMenuActionProvider';

export default {
  getCustomMenuActions() {
    return {};
  },
} as ICustomMenuActionProvider;
